import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const Alert = ({ fields }) => {
  return (
    <section className={`vds-notification vds-notification--${fields.type?.value}`}>
      <div className="vds-notification__inner">
        <div className="vds-notification__icon-container">
          <span className="vds-notification__icon-status"></span>
        </div>
        <div className="vds-notification__body">
          <div className="vds-notification__content">
            {fields.title?.value && (
              <div className="vds-notification__title-container">
                <Text tag="h2" className="vds-notification__title" field={fields.title} />
              </div>
            )}
            <div className="vds-notification__message">
              {fields.intro?.value && (
                <div className="vds-notification__message-intro">
                  <RichText field={fields.intro} />
                </div>
              )}
              {fields.message?.value && (
                <div className="vds-notification__message-main">
                  <RichText field={fields.message} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Alert;
